export default {
    data() {
        return {

        }
    },

    watch: {

    },

    created() {

    },

    methods: {
        clickItem() {
            if(this.status == 1) {

                this.$emit('load');

            }

        }
    }
}
